import { ChangeDetectionStrategy, Component, OnDestroy, OnInit } from '@angular/core'
import { NavigationEnd, Router, RouterOutlet } from '@angular/router'
import { Subscription } from 'rxjs'
import { SplashScreenService } from './_metronic/partials/layout/splash-screen/splash-screen.service'
import { TableExtendedService } from './_metronic/shared/crud-table'
import { TranslationService } from './modules/i18n/translation.service'
import { locale as enLang } from './modules/i18n/vocabs/en'
import { locale as frLang } from './modules/i18n/vocabs/fr'
import { SplashScreenComponent } from './_metronic/partials/layout/splash-screen/splash-screen.component'

@Component({
    // tslint:disable-next-line:component-selector
    selector: 'body[root]',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [RouterOutlet, SplashScreenComponent],
})
export class AppComponent implements OnInit, OnDestroy {
  private unsubscribe: Subscription[] = []
  hide: boolean = true

  constructor(
    private translationService: TranslationService,
    private splashScreenService: SplashScreenService,
    private router: Router,
    private tableService: TableExtendedService,
   // private cacheService: CacheService
  ) {
    // register translations
    //this.cacheService.checkForUpdates();
    this.translationService.loadTranslations(enLang, frLang)
    //this.cacheService.checkForUpdates()
  }

  // private versionCheckInterval: any

  ngOnInit() {
    // Vérification immédiate au démarrage
    //this.versionCheckerService.checkVersion();
    // this.versionCheckInterval = setInterval(() => {
    //   this.versionCheckerService.checkVersion();
    // }, 5 * 60 * 1000); // toutes les 5 minutes

    // Vérification périodique toutes les 5 secondes
    // this.versionCheckInterval = setInterval(() => {
    //   this.versionCheckerService.checkVersion();
    // }, 5000);

    const routerSubscription = this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        // clear filtration paginations and others
        this.tableService.setDefaults()
        // hide splash screen
        this.splashScreenService.hide()

        // scroll to top on every route change
        window.scrollTo(0, 0)

        // to display back the body content
        setTimeout(() => {
          document.body.classList.add('page-loaded')
        }, 500)

        //  ;(window as any).HubSpotConversations.widget.refresh()
      }
    })
    this.unsubscribe.push(routerSubscription)
  }

  ngOnDestroy() {
    this.unsubscribe.forEach(sb => sb.unsubscribe())
  }

  hideCookies() {
    this.hide = false
  }
}
